export class Categoria {
  id: number;
  nombre: String;
  constructor() {

  }
}